export default {
  namespaced: true,
  state: {
    model: false,
    text: "",
    timeout: 3000,
    color: "",
  },
  mutations: {
    close(state) {
      state.model = false;
    },
    set_model(state, data) {
      state.model = data;
    },
    open(state, { text, color }) {
      console.log("text, color", text);
      state.model = true;
      state.color = color;
      state.text = text;
    },
  },
  actions: {},
  getters: {
    model: (state) => state.model,
  },
};
